/**
 * AdminOrcaEventsRpcClient - AtomRpc integration for admin orca events endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaEventsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaEventsRpcClient extends AtomRpc.Tag<AdminOrcaEventsRpcClient>()(
  "AdminOrcaEventsRpcClient",
  {
    group: AdminOrcaEventsRpcs,
    protocol: makeRpcClientLayer(AdminOrcaEventsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
